import { atom } from "jotai";

interface PopupState {
  userId: number;
  instanceId: string;
}

// アクティブなポップアップのユーザーIDとインスタンスID
export const activePopupUserIdAtom = atom<PopupState | null>(null);
// アクティブなポップアップを開いたトリガー要素ID
export const activePopupTriggerIdAtom = atom<string | null>(null);

// ポップアップの位置情報
export const popupPositionAtom = atom<{ top: number; left: number }>({
  top: 0,
  left: 0,
});

// メッセージ送信処理中のユーザーID管理
export const messageLoadingUsersAtom = atom<Set<number>>(new Set<number>());

export const setMessageLoadingAtom = atom(
  null,
  (get, set, { userId, isLoading }: { userId: number; isLoading: boolean }) => {
    const current = get(messageLoadingUsersAtom);
    const newSet = new Set(current);

    if (isLoading) {
      newSet.add(userId);
    } else {
      newSet.delete(userId);
    }

    set(messageLoadingUsersAtom, newSet);
  },
);
